import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import * as Sentry from "@sentry/vue";
import router from './router'

import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'
import '@fortawesome/fontawesome-pro/css/solid.min.css'
import '@fortawesome/fontawesome-pro/css/light.min.css'
import '@fortawesome/fontawesome-pro/css/duotone.min.css'
import './assets/app.scss'

// const TZ_AGNOSTIC_FORMAT = 'yyyy-MM-ddTHH:mm:ss';
const app = createApp(App)

declare global {
  interface Date {
    addDays(days: number): Date;
    TZ_AGNOSTIC_FORMAT: string
  }
  interface String {
    toTitleCase(str: string): string;
  }
  interface Array<T> {
    at(index: number): T;
  }
}

Date.prototype.TZ_AGNOSTIC_FORMAT = 'yyyy-MM-ddTHH:mm:ss';
Date.prototype.addDays = function (days: number) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

String.prototype.toTitleCase = (str: string) => {
  return str.toLowerCase().split(' ').map((word: string) => {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

app.provide('kendo', new IntlService('en-US'));
const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

app.use(pinia);

router.beforeEach((to, from, next) => {
  document.body.setAttribute("tabindex", "-1");
  document.body.focus();
  document.body.removeAttribute("tabindex");

  const visibleTooltips = document.querySelectorAll("[role=tooltip]");
  [...visibleTooltips].map(element => element.remove())

  if (to.name !== from.name) {
    useAppDataStore().clearContext()
  }

  next();
});

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        }
      }),
      Sentry.browserTracingIntegration({ router }),
    ]
  });
}

app.use(router);
app.mount('#app')

import { IntlService } from '@progress/kendo-vue-intl'
import "@popperjs/core/dist/umd/popper.js"
import "bootstrap"
import { useAppDataStore } from '@/stores/app'
import { createSentryPiniaPlugin } from '@sentry/vue'
